import React, {useRef, useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {showToast} from '../../common/app_common';
import {postApiTokenIssue, checkPermission, PERMISSION_ADMIN, PERMISSION_OPERATOR} from '../../common/fetch_api/api_common';

export const AddToken = ({curPermission, show, handleClose, update }) => {

    const tokenName = useRef('');
    const permission = useRef('');
    const expires = useRef('');

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
        if(tokenName.current.value === '')
        {
            showToast("The Name must not be empty", 'error');
        }
        else
        {
            const expire = parseInt( (new Date().getTime() / 1000) + ( parseInt(expires.current.value) * 3600 ) );
            Promise.resolve( postApiTokenIssue(tokenName.current.value, permission.current.value, expire) )
            .then( done => {
                closeModal();
                update();
            });
        }
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Create Token</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='control-token-modal'>
                    <div className="d-flex">
                        <div className="col-4 label-box">Name</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="text" ref={tokenName}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Permission</div>
                        <div className="col-8">
                            <select className="form-select form-select-sm" defaultValue={curPermission} ref={permission}>
                                <option disabled={`${checkPermission(PERMISSION_ADMIN, false)?'':'disabled'}`} value='admin'>admin</option>
                                <option disabled={`${checkPermission(PERMISSION_OPERATOR, false)?'':'disabled'}`} value='operator'>operator</option>
                                <option value='monitoring'>monitoring</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Expires</div>
                        <div className="col-8">
                            <select className="form-select form-select-sm" defaultValue={'168'} ref={expires}>
                                <option value='1'>1 hour</option>
                                <option value='12'>12 hour</option>
                                <option value='24'>1 day</option>
                                <option value='168'>7 day</option>
                                <option value='336'>14 day</option>
                                <option value='720'>1 month</option>
                                <option value='4320'>6 month</option>
                            </select>
                        </div>
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Create</Button>
            </Modal.Footer>
        </Modal>
    );
};